module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/1@2x_2e949cc6425bd798108f1508c041e39f.png";